export default [
  {
    caption: 'Delete device',
    action: 'deleteDevice',
  },
];
